import { RuntimeContract, WriteBacks } from '@getvim/vim-connect';
import { WriteBackProvider } from '../../../../types';

export interface UseWriteBack {
  writeProvider: WriteProvider;
  writeAuthCode: WriteAuthCode;
  writeFacility: WriteFacility;
}

export type WritebackReferralInput = Pick<
  WriteBacks.UpdateReferral,
  'authCode' | 'notes' | 'targetProvider'
>;

export type WritebackReferralCallback = (
  data: WritebackReferralInput,
  config?: Partial<RuntimeContract.Incoming.UpdateReferralWritebackConfiguration>,
) => void;

export type WritebackOrderInput = {
  notes?: string;
  targetProvider?: WriteBackProvider;
};

export type WritebackOrderCallback = (data: WritebackOrderInput) => void;

type WriteProvider = (provider: WriteBackProvider) => Promise<{ success: boolean; error?: string }>;

type WriteAuthCode = (authCode: string) => Promise<{ success: boolean; error?: string }>;

type WriteFacility = (facility: WriteBackProvider) => Promise<{ success: boolean; error?: string }>;

export const DEFAULT_NUMBER = '0000000000';
